
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DELETE_MANAGER_CONTRACTOR from "@/apollo/contractors/DeleteContractorFromManagerDB.gql";

  import UIButton from "@/components/button/ui-button.vue";

  import Message from "@/data/notificationsMessages";
  import { NOTIFICATION } from "@/entities/Events";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class RemoveManagerContractorRequest extends Vue {
    @Prop({ type: String, required: true }) readonly managerId!: string;
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, default: "secondary" }) readonly buttonVariant!: string;
    @Prop({ type: String, default: undefined }) readonly buttonSize!: string;
    @Prop({ type: Boolean, default: false }) readonly fullWidth!: boolean;

    processing = false;

    async revokeRequest(): Promise<void> {
      this.processing = true;
      try {
        await this.deleteManagerContractor();
        this.$emit("requestRemoved");
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.processing = false;
      }
    }

    deleteManagerContractor() {
      return this.$apollo.mutate({
        mutation: DELETE_MANAGER_CONTRACTOR,
        variables: {
          where: {
            _and: [
              {
                manager_id: { _eq: this.managerId },
              },
              { contractor_id: { _eq: this.contractorId } },
            ],
          },
        },
      });
    }
  }
